<template>
    <div>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :offset="offset"
          finished-text="没有更多了"
          @load="loadMore"
        >
          <div
            class="commission-item"
            v-for="(item, i) in dataList"
            :key="i"
          >
            <div>
              <div class="thead van-hairline--bottom">
                <div class="thead-left">
                  <img :src="item.HeadPic" alt="" class="avatar" />
                  <div class="name">{{ item.NickName }}</div>
                </div>
                <div class="thead-right">
                  会员级员：<span class="grade">{{
                    item.DistributionLevelName
                  }}</span>
                </div>
              </div>
              <div class="tbody">
                <!-- <div class="th">
                  <img :src="item.productCoverPhoto" alt="" class="thumb" />
                </div> -->
                <div class="bd">
                  <!-- <div class="one-line">
                    <div class="goods-name">{{ item.productName }}</div>
                    <div class="price">￥{{ item.sellPrice }}</div>
                  </div> -->
                  <div class="two-line">
                    <div class="date">分佣时间:{{ item.AddDatetime }}</div>
                    <!-- <div class="num">X{{ item.buyCount }}</div> -->
                  </div>
                  <div class="three-line">
                    <div class="commission">
                      描述：{{ item.TransactionDescription }}
                      <br />
                      处理状态：{{
                        getTransactionStatusText(item.LX_TransactionStatus)
                      }}
                      <br />
                      佣金:<span class="hlight">￥{{ item.PayableCoinCount }}元</span>
                    </div>
                    <!-- <div class="show-btn">查看详情</div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </template>
  
  <script>
  import common from "../tools/common";
  

  export default {
    data() {
      return {
        options: {
          type: "GetMemberAgentCommissionList",
          pageIndex: 1,
          time: this.time
        },
        offset: 100,
        refreshing: false,
        loading: true,
        finished: false,
        dataList: []
      };
    },
    components: {},
    props: {
      time: String
    },
    mounted() {
  
    },
    computed: {
      getTransactionStatusText() {
        return function(val) {
          return common.Text.getTransactionStatusText(val);
        };
      }
    },
    methods: {
      init() {
        this.getList();
      },
      goCommissionPage(orderId) {
        this.$router.push("/orderDetails?id=" + orderId);
      },
  
      onRefresh() {
        this.finished = false;
        this.loading = true;
        Object.assign(this.options, {
          current: 1
        });
  
        this.getList();
      },
      loadMore() {
        Object.assign(this.options, {
          current: this.options.pageIndex + 1
        });
  
        this.loading = true;
        this.getList();
      },
      getList() {
        var that = this;
        var _options=that.options;
        this.$store.dispatch(_options).then(
          res => {
            console.log(res,"getList");
            that.loading = false;
            if (that.refreshing) {
              that.refreshing = false;
            }
            common.Response.callNotMsgResponse(res, function(result) {
              if (result.length <= 0) {
                that.finished = true;
              }
              if (_options.current > 1) {
                if (result.length > 0) {
                  result.forEach(element => {
                    that.dataList.push(element);
                  });
                }
              } else {
                that.dataList = result;
              }
            });
          },
          error => {
            console.log(error);
          }
        );
      }
    },
    watch: {
      time: function(curVal, oldval) {
        if (curVal != oldval) {
          Object.assign(this.options, {
            current: 1,
            time: curVal
          });
          this.getList();
        }
      }
    },
    created() {
      this.init();
    }
  };
  </script>
  <style lang="less" scoped>
  .commission-area-box {
    width: 100%;
    height: auto;
    padding-bottom: 10.5px;
    position: relative;
  }
  
  .commission-area-box > .bg {
    width: 100%;
    display: block;
    position: absolute;
    top: 0;
    background-size: 100% 100%;
    height: 115px;
  }
  .profit-box {
    background: url("~@/assets/images/cash-bag.png") #fff right 25px center
      no-repeat;
    background-size: 42px 48px;
    padding: 12px 18px;
    margin: 0 10px;
    border-radius: 6px;
    z-index: 1;
    position: relative;
    margin-bottom: 15px;
    .bd {
      .check-date {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        .month {
          font-size: 15px;
          color: #1d1d1d;
        }
        .year {
          margin-left: 14px;
          font-size: 12px;
          color: #7d7d7d;
        }
      }
      .profit-total {
        display: flex;
        align-items: center;
        .profit-total-tit {
          font-size: 12px;
          color: #737373;
          margin-right: 8px;
        }
        .profit-total-price {
          font-size: 21px;
          color: #1d1d1d;
        }
      }
    }
  }
  //佣金item
  .commission-item {
    margin: 10px;
    background: #fff;
    padding: 0 14px;
    border-radius: 6px;
    overflow: hidden;
    box-sizing: border-box;
    .thead {
      display: flex;
      align-items: center;
      padding: 10px 0;
      .thead-left {
        flex: 1;
        overflow: hidden;
        display: flex;
        align-items: center;
        .avatar {
          width: 26px;
          height: 26px;
          border-radius: 50%;
          object-fit: cover;
          margin-right: 8px;
        }
        .name {
          font-size: 13px;
          color: #3d3c3c;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .thead-right {
        margin-left: 15px;
        flex: 1;
        overflow: hidden;
        text-align: right;
        font-size: 12px;
        color: #ababab;
        .grade {
          color: #3d3c3c;
        }
      }
    }
    .tbody {
      display: flex;
      align-items: center;
      padding: 12px 0 15px;
      .th {
        margin-right: 15px;
        .thumb {
          width: 58px;
          height: 58px;
          object-fit: cover;
          border-radius: 4px;
        }
      }
      .bd {
        flex: 1;
        overflow: hidden;
        .one-line {
          display: flex;
          align-items: center;
          overflow: hidden;
          margin-bottom: 6px;
          .goods-name {
            flex: 1;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 14px;
            color: #000000;
          }
          .price {
            margin-left: 15px;
            font-size: 14px;
            color: #000000;
            font-family: Arial, Helvetica, sans-serif;
          }
        }
        .two-line {
          display: flex;
          align-items: center;
          overflow: hidden;
          .date {
            flex: 1;
            overflow: hidden;
            font-size: 12px;
            color: #b7b7b7;
          }
          .num {
            font-size: 10px;
            color: #b7b7b7;
            margin-left: 15px;
          }
        }
        .three-line {
          margin-top: 3px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .commission {
            font-size: 10px;
            color: #000;
            .hlight {
              color: #ff375b;
              font-size: 13px;
            }
          }
          .show-btn {
            margin-left: 15px;
            line-height: 1;
            font-size: 12px;
            padding: 4px 8px;
            border: 1px solid;
            color: #464646;
            border-radius: 999px;
          }
        }
      }
    }
  }
  //老板
  .laoban-item {
    margin: 10px;
    background: #fff;
    padding: 18px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    .th {
      margin-right: 12px;
      .avatar {
        width: 52px;
        height: 52px;
        object-fit: cover;
        border-radius: 50%;
      }
    }
    .bd {
      flex: 1;
      overflow: hidden;
      .name {
        font-size: 14px;
        color: #000;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .yeji {
        margin-top: 6px;
        font-size: 12px;
        color: #8e8e8e;
        .num {
          color: #000;
        }
      }
    }
    .ft {
      margin-left: 15px;
      text-align: right;
      .tuandui {
        font-size: 12px;
        color: #8e8e8e;
        .num {
          color: #3c3c3c;
        }
      }
      .jiang {
        font-size: 12px;
        color: #8e8e8e;
        margin-top: 4px;
        .num {
          color: #ff375b;
          font-size: 13px;
        }
      }
    }
  }
  </style>
  